import { RichText } from 'prismic-reactjs';
import styled from 'styled-components';

import { Cell, HeaderCell, PlanLabelCell, Table, TableScroll } from './Table';

const PricingTable = styled(Table)`
  min-width: 100%;
`;

export const PricingPlanLabelCell = styled(PlanLabelCell)`
  text-align: left;
  width: 30%;
`;

const TableRow = styled.tr`
  &:last-child {
    ${Cell} {
      border-bottom: none;
    }
  }
`;

export function InternationalPricingTable({ pricing }) {
  return (
    <TableScroll>
      <PricingTable>
        <thead>
          <tr>
            <HeaderCell>Currency</HeaderCell>
            <PricingPlanLabelCell>If billed annually</PricingPlanLabelCell>
            <PricingPlanLabelCell>If billed monthly</PricingPlanLabelCell>
          </tr>
        </thead>
        <tbody>
          {pricing.map(
            (
              { currency, billed_annually: billedAnnually, billed_monthly: billedMonthly },
              index
            ) => (
              <TableRow key={index}>
                <Cell>
                  {currency.__typename === 'Currency' ? (
                    <p>{`${currency.iso_4217_code} (${currency.symbol})`}</p>
                  ) : (
                    <RichText render={currency} />
                  )}
                </Cell>
                <Cell>
                  <RichText render={billedAnnually} />
                </Cell>
                <Cell>
                  <RichText render={billedMonthly} />
                </Cell>
              </TableRow>
            )
          )}
        </tbody>
      </PricingTable>
    </TableScroll>
  );
}
